import { logger } from "./utils/logger";
/* eslint-disable */
/* eslint-disable no-unused-vars */
import logo from "./logo.svg";
import React, { useState, useRef, useEffect, lazy } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  useLocation,
  /*
  課題・障害番号: IH-BUG-551
  対応日: 2026/05/23
  担当者: 檜垣
  修正概要: PC画面サイズで健診結果メールURLを開いた際、健診一覧へリダイレクトするためNavigateを追加
  */
  Navigate,
  /*
  END
  課題・障害番号: IH-BUG-551
  */
} from "react-router-dom";
import { fetchAuthSession } from "aws-amplify/auth";
/*
課題・障害番号: 残課題-40
対応日: 2026/3/23
担当者: 久留
修正概要: 権限に関する表示制御の実装
*/
import AuthRouteGuard from "./routes/AuthRouteGuard";
import RoleRouteGuard from "./routes/RoleRouteGuard";
/*
END
課題・障害番号: 残課題-40
*/
import { AuthProvider } from "./store/auth/AuthProvider";

import { AUTH } from "./constants/Constants";
import { localStorageClient } from "./storage/localStorageClient";
import { STORAGE_KEYS } from "./storage/storageKeys";

import { UnreadProvider } from "./context/UnreadContext";
import { getFetch } from "./api/apiClient";

import { CommonLoadingProvider, useCommonLoading } from "./context/CommonLoadingContext";
import RumErrorBoundary from "./components/RumErrorBoundary";

/*
課題・障害番号: なし
対応日: 2026/3/27
担当者: 石川
修正概要: エラー画面を追加
*/
import ErrorPage from "./pages/Pc/ControlPanel/panels/LoginPanel/ErrorPage";

const Sidebar = lazy(() => import("./layouts/Sidebar"));
const SidebarPage = lazy(() => import("./layouts/SidebarPage"));
const MainTabs = lazy(() => import("./layouts/MainTabs"));
const Hospital = lazy(
  () => import("./pages/Pc/ControlPanel/panels/SystemManagementWeb/Hospital/Hospital")
);
const HospitalEdit = lazy(
  () => import("./pages/Pc/ControlPanel/panels/SystemManagementWeb/Hospital/HospitalEdit")
);
const Company = lazy(
  () => import("./pages/Pc/ControlPanel/panels/SystemManagementWeb/Company/Company")
);
const CompanyEdit = lazy(
  () => import("./pages/Pc/ControlPanel/panels/SystemManagementWeb/Company/CompanyEdit")
);
const Kenpo = lazy(() => import("./pages/Pc/ControlPanel/panels/SystemManagementWeb/Kenpo/Kenpo"));
const KenpoEdit = lazy(
  () => import("./pages/Pc/ControlPanel/panels/SystemManagementWeb/Kenpo/KenpoEdit")
);
const HealthCheck = lazy(
  () => import("./pages/Pc/ControlPanel/panels/SystemManagementWeb/HealthCheck/HealthCheck")
);

const HealthCheckListScreen = lazy(
  () => import("./pages/Mobile/HealthCheck/HealthCheck/HealthCheckListScreen")
);
const HealthCheckNewRegistrationScreen = lazy(
  () => import("./pages/Mobile/HealthCheck/HealthCheck/HealthCheckNewRegistrationScreen")
);
const HealthCheckCameraAdd = lazy(
  () => import("./pages/Mobile/HealthCheck/HealthCheck/HealthCheckCameraAdd")
);
const HealthCheckDetailScreen = lazy(
  () => import("./pages/Mobile/HealthCheck/HealthCheck/HealthCheckDetailScreen")
);
const HealthCheckMoreDetailScreen = lazy(
  () => import("./pages/Mobile/HealthCheck/HealthCheck/HealthCheckMoreDetailScreen")
);

const SettingsMenu = lazy(() => import("./pages/Mobile/Settings/SettingsMenu"));
const ProfileScreen = lazy(() => import("./pages/Mobile/Settings/Profile/ProfileScreen"));
const AlignmentLinkagePage = lazy(
  () => import("./pages/Mobile/Settings/AlignmentLinkage/AlignmentLinkagePage")
);
const FamilyMedicalPage = lazy(
  () => import("./pages/Mobile/Settings/FamilyMedical/FamilyMedicalPage")
);
const DataSharingListPage = lazy(
  () => import("./pages/Mobile/Settings/DataSharing/DataSharingListPage")
);
const DataSharingDetailsPage = lazy(
  () => import("./pages/Mobile/Settings/DataSharing/DataSharingDetailsPage")
);

const DataSharingWebPage = lazy(
  () => import("./pages/Mobile/Settings/DataSharing/DataSharingWebPage")
);
const TaskWebPage = lazy(() => import("./pages/Mobile/Task/TaskWebPage"));

const DeviceLinkageMenu = lazy(
  () => import("./pages/Mobile/Settings/DeviceLinkage/DeviceLinkageMenu")
);
const DeviceLinkageDetail = lazy(
  () => import("./pages/Mobile/Settings/DeviceLinkage/DeviceLinkageDetail")
);
const AppInfoScreen = lazy(() => import("./pages/Mobile/Settings/AppInfo/AppInfoScreen"));

const CompanyWebSidebar = lazy(() => import("./layouts/CompanyWebSidebar"));
const KenpoWebSidebar = lazy(() => import("./layouts/KenpoWebSidebar"));
const HospitalWebSidebar = lazy(() => import("./layouts/HospitalWebSidebar"));
const TaskListPanel = lazy(() => import("./pages/Pc/ControlPanel/panels/Tasks/TaskListPanel"));
const TaskDetailListPanel = lazy(
  () => import("./pages/Pc/ControlPanel/panels/Tasks/TaskDetailListPanel")
);
const TaskTargetUserPanel = lazy(
  () => import("./pages/Pc/ControlPanel/panels/Tasks/TaskTargetUserPanel")
);
const TaskDetailPanel = lazy(() => import("./pages/Pc/ControlPanel/panels/Tasks/TaskDetailPanel"));
const SubDetailPanel = lazy(() => import("./pages/Pc/ControlPanel/panels/Tasks/SubDetailPanel"));
const TaskMessagePanel = lazy(
  () => import("./pages/Pc/ControlPanel/panels/Tasks/TaskMessagePanel")
);
const UserListPanel = lazy(() => import("./pages/Pc/ControlPanel/panels/Users/UserListPanel"));
const UserDetailPanel = lazy(() => import("./pages/Pc/ControlPanel/panels/Users/UserDetailPanel"));
const SettingListPanel = lazy(
  () => import("./pages/Pc/ControlPanel/panels/Settings/SettingListPanel")
);

const SurveyListPanel = lazy(
  () => import("./pages/Pc/ControlPanel/panels/CompanyWeb/Survey/Survey")
);
const SurveyEdit = lazy(
  () => import("./pages/Pc/ControlPanel/panels/CompanyWeb/Survey/SurveyEdit")
);

const Top = lazy(() => import("./pages/Mobile/Top/Top"));
const WebTop = lazy(() => import("./pages/Pc/ControlPanel/panels/EmployeeWeb/Top/Top"));

const List = lazy(() => import("./pages/Mobile/Top/List/List"));
const Task = lazy(() => import("./pages/Mobile/Task/Task"));
const TaskDetails = lazy(() => import("./pages/Mobile/Task/TaskDetails/TaskDetails"));
const TaskMessage = lazy(() => import("./pages/Mobile/Task/TaskMessage/TaskMessagePage"));
const Data = lazy(() => import("./pages/Mobile/Data/Data"));
const ConsultationList = lazy(() => import("./pages/Mobile/Data/Consultation/ConsultationList"));
const ConsultationDetail = lazy(
  () => import("./pages/Mobile/Data/Consultation/ConsultationDetail")
);
const HospitalDetaile = lazy(() => import("./pages/Mobile/Data/Hospital/HospitalDetaile"));
const Login = lazy(() => import("./pages/Pc/ControlPanel/panels/LoginPanel/LoginPage"));
const TopPanel = lazy(() => import("./pages/Pc/ControlPanel/panels/Top/TopPanel"));
const Tag = lazy(() => import("./pages/Pc/ControlPanel/panels/Tags/Tag"));
const SettingsMain = lazy(
  () => import("./pages/Pc/ControlPanel/panels/SystemManagementWeb/Settings/SettingsMain")
);
const Agreement = lazy(
  () => import("./pages/Mobile/TermsAndPolicyAgreementScreen/AgreementScreen")
);
const SurveyAnswer = lazy(
  () => import("./pages/Pc/ControlPanel/panels/CompanyWeb/Survey/SurveyAnswer")
);

const HealthMetricsMenuPage = lazy(
  () => import("./pages/Mobile/HealthMetrics/HealthMetricsMenu/HealthMetricsMenuPage")
);
const HealthMetricsGraphPage = lazy(
  () => import("./pages/Mobile/HealthMetrics/HealthMetricsGraph/HealthMetricsGraphPage")
);

const Consultation = lazy(() => import("./pages/Pc/ControlPanel/panels/Settings/SettingListPanel"));

const PasswordChangePage = lazy(
  () => import("./pages/Pc/ControlPanel/panels/LoginPanel/PasswordChangePage")
);
const EmailMfaAuthPage = lazy(
  () => import("./pages/Pc/ControlPanel/panels/LoginPanel/EmailMfaAuthPage")
);
const ForgotPasswordRequestPage = lazy(
  () => import("./pages/Pc/ControlPanel/panels/LoginPanel/ForgotPasswordRequestPage")
);
const ForgotPasswordResetPage = lazy(
  () => import("./pages/Pc/ControlPanel/panels/LoginPanel/ForgotPasswordResetPage")
);
const LifeRecord = lazy(() => import("./pages/Pc/ControlPanel/panels/HealthMetrics/LifeRecord"));
const MedicalVisitRecordsTable = lazy(
  () => import("./pages/Pc/ControlPanel/panels/MedicalVisitRecord/MedicalVisitRecordTable")
);

const AgreementComponent = lazy(() => import("./components/Mobile/AgreementComponent"));
const HealthCheckupPanel = lazy(
  () => import("./pages/Pc/ControlPanel/panels/HealthCheck/HealthCheckupPanel")
);

const employeeRoutes = [
  { path: "/EmployeeNativeApp/Data/HealthCheck", element: <HealthCheckListScreen /> },
  {
    path: "/EmployeeNativeApp/Data/HealthCheck/New",
    element: <HealthCheckNewRegistrationScreen />,
  },
  { path: "/EmployeeNativeApp/Data/HealthCheck/New/Camera", element: <HealthCheckCameraAdd /> },
  {
    path: "/EmployeeNativeApp/Data/HealthCheck/HealthCheckSummary",
    element: <HealthCheckDetailScreen />,
  },
  {
    path: "/EmployeeNativeApp/Data/HealthCheck/HealthCheckSummary/HealthCheckDetails",
    element: <HealthCheckMoreDetailScreen />,
  },
  /*
  課題・障害番号: 残課題-80
  対応日: 2026/03/17
  担当者: 檜垣
  修正概要: 健診詳細系画面を健診ID付きURLでも開けるようにルートを追加
  */
  {
    path: "/EmployeeNativeApp/Data/HealthCheck/New/Camera/:healthCheckId",
    element: <HealthCheckCameraAdd />,
  },
  {
    path: "/EmployeeNativeApp/Data/HealthCheck/HealthCheckSummary/:healthCheckId",
    element: <HealthCheckDetailScreen />,
  },
  {
    path: "/EmployeeNativeApp/Data/HealthCheck/HealthCheckSummary/HealthCheckDetails/:healthCheckId",
    element: <HealthCheckMoreDetailScreen />,
  },
  /*
  END
  課題・障害番号: 残課題-80
  */
  { path: "/EmployeeNativeApp/SettingsMenu", element: <SettingsMenu /> },
  { path: "/EmployeeNativeApp/Profile", element: <ProfileScreen /> },
  { path: "/EmployeeNativeApp/Company/Linkage", element: <AlignmentLinkagePage /> },
  { path: "/EmployeeNativeApp/Kenpo/Linkage", element: <AlignmentLinkagePage /> },
  { path: "/EmployeeNativeApp/FamilyMedical", element: <FamilyMedicalPage /> },
  { path: "/EmployeeNativeApp/DataSharing", element: <DataSharingListPage /> },
  { path: "/EmployeeNativeApp/DataSharing/HealthInformation", element: <DataSharingDetailsPage /> },
  { path: "/EmployeeNativeApp/Device/Linkage", element: <DeviceLinkageMenu /> },
  { path: "/EmployeeNativeApp/Device/Linkage/Detail", element: <DeviceLinkageDetail /> },
  { path: "/EmployeeNativeApp/AppInformation", element: <AppInfoScreen /> },
  { path: "/EmployeeNativeApp", element: <Top /> },
  { path: "/EmployeeNativeApp/List", element: <List /> },
  { path: "/EmployeeNativeApp/Task", element: <Task /> },
  { path: "/EmployeeNativeApp/Task/Detail", element: <TaskDetails /> },
  /*
  課題・障害番号: 残課題-80
  対応日: 2026/03/17
  担当者: 檜垣
  修正概要: タスク詳細画面をtaskId付きURLでも開けるようにルートを追加
  */
  { path: "/EmployeeNativeApp/Task/Detail/:taskId", element: <TaskDetails /> },
  /*
  END
  課題・障害番号: 残課題-80
  */
  { path: "/EmployeeNativeApp/Task/Talk", element: <TaskMessage /> },
  { path: "/EmployeeNativeApp/Data", element: <Data /> },
  { path: "/EmployeeNativeApp/Data/ConsultationList", element: <ConsultationList /> },
  { path: "/EmployeeNativeApp/Data/ConsultationDetail", element: <ConsultationDetail /> },
  { path: "/EmployeeNativeApp/Data/HospitalDetaile", element: <HospitalDetaile /> },
  { path: "/EmployeeNativeApp/Data/HealthMetricsMenu", element: <HealthMetricsMenuPage /> },
  { path: "/EmployeeNativeApp/Data/HealthMetricsGraph", element: <HealthMetricsGraphPage /> },
  { path: "/Agreement", element: <Agreement /> },
];

const App = () => {
  //管理パート開始
  const [stack, setStack] = useState([]);
  // タスク詳細から削除して一覧へ戻るとき、API反映タイミングによっては
  // 削除済みタスクが含まれて返るためローカル除外する用の id
  const [excludeTaskIdState, setExcludeTaskIdState] = useState(null);
  const [showAgreement, setShowAgreement] = useState(false);
  const [requireTermsAgreement, setRequireTermsAgreement] = useState(false);
  const [requirePolicyAgreement, setRequirePolicyAgreement] = useState(false);
  const [currentTermsVersion, setCurrentTermsVersion] = useState(null);
  const [currentPolicyVersion, setCurrentPolicyVersion] = useState(null);
  const agreementDialogOpenRef = useRef(false);
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

  /*
  課題・障害番号: IH-BUG-510
  対応日: 2026/05/15
  担当者: 檜垣
  修正概要: メール通知URLからの未ログインアクセスでシステムエラー画面が表示される問題を修正（同意確認API呼出前に有効セッションを検証するヘルパー）
  */
  const hasAuthSession = async () => {
    try {
      const session = await fetchAuthSession();
      return !!session?.tokens?.idToken;
    } catch (e) {
      logger.warn("fetchAuthSession failed; skip checkAgreement", e);
      return false;
    }
  };
  /*
  END
  課題・障害番号: IH-BUG-510
  */

  const AgreementWatcher = () => {
    const location = useLocation();

    /*
    課題・障害番号: IH-BUG-510
    対応日: 2026/05/15
    担当者: 檜垣
    修正概要: メール通知URLからの未ログインアクセスでシステムエラー画面が表示される問題を修正（未認証時は同意確認APIをスキップ）
    */
    useEffect(() => {
      const path = location.pathname;

      if (path === "/Agreement") return;

      if (!path.startsWith("/EmployeeWeb") && !path.startsWith("/EmployeeNativeApp")) return;

      let cancelled = false;
      (async () => {
        if (!(await hasAuthSession())) return;
        if (!cancelled) checkAgreement();
      })();

      return () => {
        cancelled = true;
      };
    }, [location.pathname]);
    /*
    END
    課題・障害番号: IH-BUG-510
    */

    return null;
  };

  useEffect(() => {
    /*
課題・障害番号: IH-BUG-396
対応日: 2026/04/16
担当者: ユリヤ
修正概要: ヘルスケア連携周りの問題修正
*/
    const handler = async (event) => {
      let data;
      try {
        data = typeof event.data === "string" ? JSON.parse(event.data) : event.data;

        if (data.type === "TOKEN_REFRESH") {
          const session = await fetchAuthSession({ forceRefresh: true });
          const idToken = session?.tokens?.idToken?.toString();

          window.ReactNativeWebView?.postMessage(
            JSON.stringify({
              type: "TOKEN_RESPONSE",
              idToken,
            })
          );
        }
      } catch (e) {
        // 何もしない
      }
    };

    window.addEventListener("message", handler);

    /*
    課題・障害番号: IH-BUG-510
    対応日: 2026/05/15
    担当者: 檜垣
    修正概要: メール通知URLからの未ログインアクセスでシステムエラー画面が表示される問題を修正（未認証時は同意確認APIをスキップ）
    */
    const runCheck = async () => {
      if (window.location.pathname === "/Agreement") return;
      const path = window.location.pathname;

      if (!path.startsWith("/EmployeeWeb") && !path.startsWith("/EmployeeNativeApp")) return;

      if (!(await hasAuthSession())) return;

      checkAgreement();
    };

    runCheck();
    /*
    END
    課題・障害番号: IH-BUG-510
    */

    const handleVisibility = () => {
      if (document.visibilityState === "visible") {
        runCheck();
      }
    };

    const handleLogin = () => {
      runCheck();
    };

    document.addEventListener("visibilitychange", handleVisibility);
    window.addEventListener("login-success", handleLogin);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibility);
      window.removeEventListener("login-success", handleLogin);
      window.removeEventListener("message", handler);
    };
    /*
END
課題・障害番号: IH-BUG-396
*/
  }, []);

  const checkAgreement = async () => {
    if (agreementDialogOpenRef.current) return;

    /*
    課題・障害番号: なし
    対応日: 2026/05/20
    担当者: 小林
    修正概要: 規約同意フローは従業員のみ対象。
              企業/健保/医療機関/システム管理者が /EmployeeWeb 配下のパスを踏んだ際、
              users テーブルに存在しないIDで GET /user が呼ばれて404となる問題を修正。
              権限が従業員(AUTH.USER)以外の場合は同意確認APIをスキップする。
    */
    const authKind = localStorageClient.get(STORAGE_KEYS.AUTH_KIND);
    if (String(authKind) !== String(AUTH.USER)) return;
    /*
    END
    課題・障害番号: なし
    */

    try {
      const res = await getFetch(`${apiBaseUrl}/user`);
      if (!res.ok) return;

      const json = await res.json();

      if (json?.data?.requireTermsAgreement || json?.data?.requirePolicyAgreement) {
        setRequireTermsAgreement(json.data.requireTermsAgreement);
        setRequirePolicyAgreement(json.data.requirePolicyAgreement);
        setCurrentTermsVersion(json.data.current_terms_version);
        setCurrentPolicyVersion(json.data.current_policy_version);

        agreementDialogOpenRef.current = true;
        setShowAgreement(true);
      } else {
        setShowAgreement(false);
      }
    } catch (e) {
      logger.error(e);
    }
  };

  const handleAgree = () => {
    agreementDialogOpenRef.current = false;
    setShowAgreement(false);
  };

  // 未読件数用
  /*
            残課題: 固定値になっていた
            対応日: 2026/3/25
            担当者: 越智
            修正概要: 自身の企業を取得し設定
          */
  // 企業webでログインしている管理者の所属する企業コードを入れる予定（次回マージ時に実装）
  // const user = { organizationId: 1 };
  /*
            END
            残課題: 固定値になっていた
          */
  /*
    故障管理一覧表: KOSHO-163
    対応日: 2026/3/27
    担当者: 越智
    修正概要: 未読件数
  */
  // URLが "/Employee" で「始まらない」場合だけ true になる
  const isCompanyAdmin = !window.location.pathname.startsWith("/Employee");
  /*
    END
    故障管理一覧表: KOSHO-163
  */

  const listPanelCloseRef = useRef(null);
  const taskDetailCleanupRef = useRef(null);
  const openCSVRegistCleanupRef = useRef(null);
  const adminPanelCloseRef = useRef(null);

  const closeTopPanel = () => {
    setStack((prev) => {
      if (listPanelCloseRef.current) listPanelCloseRef.current();
      return prev.slice(0, -1);
    });
  };

  /*
  課題・障害番号: IH-BUG-550
  対応日: 2026/05/23
  担当者: 檜垣
  修正概要: メッセージ通知メールURLから遷移時、メッセージタブを開いた状態で
            対象従業員 (soh_id) を自動選択するため initialUserId を伝搬。
  */
  const openTaskDetailList = (program, defaultTab, status, refresh, initialUserId) => {
    setStack([
      <TaskDetailListPanel
        defaultTab={defaultTab}
        key="TaskDetailList"
        program={program}
        status={status}
        refresh={refresh}
        initialUserId={initialUserId}
        openSubDetail={openSubDetail}
        openTaskList={openTaskList}
        onDetailClose={listPanelCloseRef}
        openTaskDetailList={openTaskDetailList}
        viewEinsPanel={true}
      />,
    ]);
  };
  /*
  END
  課題・障害番号: IH-BUG-550
  */
  /**
   * タスク対象者画面の開閉処理
   * @param {*} program 従業員タスク情報
   */
  const openTaskTargetUser = (program) => {
    setStack([
      <TaskTargetUserPanel
        defaultTab={1}
        key={program.id}
        program={program}
        openTaskList={openTaskList}
        openSubDetail={openSubDetail}
        openMessage={openUnreadMessages}
        openTaskDetail={openTaskDetail}
        onInternalCloseRef={taskDetailCleanupRef}
        closeTopSubDetail={closeTopPanel}
        offset={0}
        onExitStart={() => {
          if (taskDetailCleanupRef.current) taskDetailCleanupRef.current();
        }}
      />,
    ]);
  };

  /**
   * タスク詳細画面の開閉処理
   * @param {*} program 従業員タスク情報
   */
  const openTaskDetail = (program) => {
    setStack([
      <TaskDetailPanel
        key="taskDetail"
        program={program}
        openTaskDetailList={openTaskDetailList}
        onInternalCloseRef={taskDetailCleanupRef}
        closeTopSubDetail={closeTopPanel}
        offset={0}
        onExitStart={() => {
          if (taskDetailCleanupRef.current) taskDetailCleanupRef.current();
        }}
      />,
    ]);
  };

  /*
  課題・障害番号: なし
  対応日: 2026/04/08
  担当者: 檜垣
  修正概要: 退職者一覧から開いた従業員詳細へ表示制御用フラグを引き継ぐ
  */
  const openUserDetail = (program, onUpdateFromList, options = {}) => {
    setStack((prev) => {
      const isReplacing =
        prev.length > 0 && ["userDetail"].includes(prev[prev.length - 1].props?.discrimination);

      const detailPanel = (
        <UserDetailPanel
          discrimination={`userDetail`}
          key={`user-${program.userID ?? program.sohid ?? program.id ?? Math.random()}-${options.isRetirementDetail ? "retired" : "active"}`}
          item={program}
          program={program}
          isRetirementDetail={options.isRetirementDetail === true}
          openSubDetail={openSubDetail}
          onInternalCloseRef={taskDetailCleanupRef}
          closeTopSubDetail={closeTopPanel}
          onUpdate={onUpdateFromList}
          offset={210}
          bounceKey={isReplacing ? Date.now() : null}
          onExitStart={() => {
            if (taskDetailCleanupRef.current) taskDetailCleanupRef.current();
          }}
        />
      );

      if (isReplacing) {
        return [...prev.slice(0, -1), detailPanel];
      } else {
        return [...prev, detailPanel];
      }
    });
  };
  /*
  END
  課題・障害番号: なし
  */

  // タスク内未読メッセージ画面の開閉処理
  const openUnreadMessages = (program) => {
    setStack([
      <TaskMessagePanel
        defaultTab={2}
        key={program.id}
        program={program}
        openTaskList={openTaskList}
        openTaskTargetUser={openTaskTargetUser}
        openTaskDetail={openTaskDetail}
        openSubDetail={openSubDetail}
        onInternalCloseRef={taskDetailCleanupRef}
        closeTopSubDetail={closeTopPanel}
        offset={0}
        onExitStart={() => {
          if (taskDetailCleanupRef.current) taskDetailCleanupRef.current();
        }}
      />,
    ]);
  };

  /**
   *
   * タスク詳細の更に詳細画面に遷移する処理(推測)
   * @param {*} subItem クリックしたタスクの内容(推測)
   * @param {*} parentProductId 親タスクのID(推測)
   */
  const openSubDetail = (subItem, parentProductId) => {
    setStack((prev) => {
      const topPanel = prev[prev.length - 1];
      const isSubDetail =
        // ["test", "csvRegist"].includes(prev[prev.length - 1].key)
        topPanel.type === SubDetailPanel && topPanel.props.parentProductId === parentProductId;

      if (isSubDetail) {
        const bounceKey = Date.now();
        const newStack = [...prev];
        newStack[newStack.length - 1] = (
          <SubDetailPanel
            key={subItem.id}
            item={subItem}
            parentProductId={parentProductId}
            close={closeTopPanel}
            offset={435}
            bounceKey={bounceKey}
            bounce
          />
        );
        return newStack;
      }
      return [
        ...prev,
        <SubDetailPanel
          key={subItem.id}
          item={subItem}
          parentProductId={parentProductId}
          close={closeTopPanel}
          offset={435}
          bounce
          onBeforeClose={() => {
            if (taskDetailCleanupRef.current) taskDetailCleanupRef.current();
          }}
        />,
      ];
    });
  };

  // タスク一覧画面の表示・非表示
  const openTaskList = (excludeTaskId = null) => {
    // ルート側の TaskListPanel にも除外IDが伝わるようApp State にも保持
    setExcludeTaskIdState(excludeTaskId);
    // stack をクリアすると下層のルート TaskListPanel が表示される
    setStack([]);
  };

  // アンケート一覧画面の表示・非表示
  const openSurveyList = () => {
    setStack([
      <SurveyListPanel
        openSurveyList={openSurveyList}
        // openPrograms={openPrograms}
        // openDetail={openProgramDetail}
        openSurveyEdit={openSurveyEdit}
      />,
    ]);
  };

  // アンケート編集画面の表示
  const openSurveyEdit = (param) => {
    setStack([
      <SurveyEdit
        openSurveyList={openSurveyList}
        // openPrograms={openPrograms}
        // openDetail={openProgramDetail}
        openSurveyEdit={openSurveyEdit}
        param={param}
      />,
    ]);
  };

  const AppLayout = () => (
    <div className="sys-app-container">
      <Sidebar />
      <main className="sys-content">
        <Outlet />
      </main>
    </div>
  );

  const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  const employeeWebRoutes = [
    /*
    課題・障害番号: KOSHO-33
    対応日: 2026/03/18
    担当者: ユリヤ
    修正概要: スマホ版のときスマホ用の画面へ遷移、PC版のときPC用の画面へ遷移
    */
    {
      path: "/EmployeeWeb/Data/HealthCheck",
      element: isMobile ? <HealthCheckListScreen /> : <HealthCheckupPanel />,
    },
    /*
    END
    課題・障害番号: KOSHO-33
    */
    {
      path: "/EmployeeWeb/Data/HealthCheck/New",
      element: <HealthCheckNewRegistrationScreen />,
    },
    { path: "/EmployeeWeb/Data/HealthCheck/New/Camera", element: <HealthCheckCameraAdd /> },
    {
      path: "/EmployeeWeb/Data/HealthCheck/HealthCheckSummary",
      element: <HealthCheckDetailScreen />,
    },
    /*
  課題・障害番号: 残課題-80
  対応日: 2026/03/17
  担当者: 檜垣
  修正概要: EmployeeWeb側も健診ID付きURLで健診詳細画面へ遷移できるようにルートを追加
  */
    {
      path: "/EmployeeWeb/Data/HealthCheck/New/Camera/:healthCheckId",
      element: <HealthCheckCameraAdd />,
    },
    /*
    課題・障害番号: IH-BUG-551
    対応日: 2026/05/23
    担当者: 檜垣
    修正概要: 健診結果登録完了メールのURLをPCブラウザで開いた際、ネイティブ用詳細画面ではなくPC版健診一覧へ遷移するよう画面サイズ(UA)で分岐
    */
    {
      path: "/EmployeeWeb/Data/HealthCheck/HealthCheckSummary/:healthCheckId",
      element: isMobile ? (
        <HealthCheckDetailScreen />
      ) : (
        <Navigate
          to="/EmployeeWeb/Data/HealthCheck"
          replace
        />
      ),
    },
    /*
    END
    課題・障害番号: IH-BUG-551
    */
    /*
    課題・障害番号: IH-BUG-551
    対応日: 2026/05/23
    担当者: 檜垣
    修正概要: 健診結果さらに詳細URLをPCブラウザで開いた際もネイティブ用画面ではなくPC版健診一覧へ遷移するよう画面サイズ(UA)で分岐
    */
    {
      path: "/EmployeeWeb/Data/HealthCheck/HealthCheckSummary/HealthCheckDetails/:healthCheckId",
      element: isMobile ? (
        <HealthCheckMoreDetailScreen />
      ) : (
        <Navigate
          to="/EmployeeWeb/Data/HealthCheck"
          replace
        />
      ),
    },
    /*
    END
    課題・障害番号: IH-BUG-551
    */
    /*
    END
    課題・障害番号: 残課題-80
    */
    {
      path: "/EmployeeWeb/Data/HealthCheck/HealthCheckSummary/HealthCheckDetails",
      element: <HealthCheckMoreDetailScreen />,
    },
    { path: "/EmployeeWeb/SettingsMenu", element: <SettingsMenu /> },
    { path: "/EmployeeWeb/Profile", element: <ProfileScreen webFlag={!isMobile} /> },
    { path: "/EmployeeWeb/Company/Linkage", element: <AlignmentLinkagePage webFlag={!isMobile} /> },
    { path: "/EmployeeWeb/Kenpo/Linkage", element: <AlignmentLinkagePage webFlag={!isMobile} /> },
    {
      path: "/EmployeeWeb/DataSharing",
      element: isMobile ? <DataSharingListPage /> : <DataSharingWebPage webFlag={!isMobile} />,
    },
    { path: "/EmployeeWeb/DataSharing/HealthInformation", element: <DataSharingDetailsPage /> },
    { path: "/EmployeeWeb/Device/Linkage", element: <DeviceLinkageMenu /> },
    /*
    課題・障害番号: KOSHO-119
    対応日: 2026/3/29
    担当者: 影山
    修正概要: PC版からは参照していないDeviceLinkageDetailの削除
    { path: "/EmployeeWeb/Device/Linkage/Detail", element: <DeviceLinkageDetail /> },
    */
    /*
    END
    課題・障害番号: KOSHO-119
    */
    { path: "/EmployeeWeb/AppInformation", element: <AppInfoScreen webFlag={!isMobile} /> },
    { path: "/EmployeeWeb", element: isMobile ? <Top /> : <WebTop /> },
    { path: "/EmployeeWeb/List", element: <List /> },
    { path: "/EmployeeWeb/Tasks", element: <TaskWebPage webFlag={!isMobile} /> },
    /*
    課題・障害番号: 残課題-80
    対応日: 2026/03/17
    担当者: 檜垣
    修正概要: EmployeeWebのタスク一覧/詳細画面をtaskId付きURLでも開けるようにルートを追加
    */

    /*
    課題・障害番号: IH-BUG-559
    対応日: 2026/05/23
    担当者: 越智
    修正概要: タスク詳細URLをPCブラウザで開いた際の分岐修正
    */
    {
      path: "/EmployeeWeb/Tasks/:taskId",
      element: isMobile ? (
        // スマホ用の画面
        <TaskDetails />
      ) : (
        // PC用の画面
        <TaskWebPage webFlag={!isMobile} />
      ),
    },
    /*
    END
    課題・障害番号: IH-BUG-559
    */
    { path: "/EmployeeWeb/Task", element: <Task isMobileWeb={isMobile} /> },
    { path: "/EmployeeWeb/Task/Detail", element: <TaskDetails /> },
    { path: "/EmployeeWeb/Task/Detail/:taskId", element: <TaskDetails /> },
    /*
    END
    課題・障害番号: 残課題-80
    */
    { path: "/EmployeeWeb/Task/Talk", element: <TaskMessage /> },
    { path: "/EmployeeWeb/Data", element: <Data /> },
    { path: "/EmployeeWeb/Data/ConsultationList", element: <ConsultationList /> },
    { path: "/EmployeeWeb/Data/ConsultationDetail", element: <ConsultationDetail /> },
    { path: "/EmployeeWeb/Data/HospitalDetaile", element: <HospitalDetaile /> },
    { path: "/EmployeeWeb/Data/HealthMetricsMenu", element: <HealthMetricsMenuPage /> },
    { path: "/EmployeeWeb/Data/HealthMetricsGraph", element: <HealthMetricsGraphPage /> },
    { path: "/EmployeeWeb/FamilyMedical", element: <FamilyMedicalPage webFlag={!isMobile} /> },
    { path: "/EmployeeWeb/Task/Survey", element: <SurveyAnswer /> },
    { path: "/EmployeeWeb/MedicalVisitRecord", element: <MedicalVisitRecordsTable /> },
    { path: "/EmployeeWeb/HealthMetrics", element: <LifeRecord webFlg={"Employee"} /> },
  ];

  const EmployeeAppLayout = () => {
    const location = useLocation();

    const getHeaderFromPath = () => {
      const path = location.pathname;
      if (
        (path.startsWith("/EmployeeWeb/Data") ||
          path.startsWith("/EmployeeWeb/MedicalVisitRecord") ||
          path.startsWith("/EmployeeWeb/HealthMetrics")) &&
        !path.startsWith("/EmployeeWeb/DataSharing")
      ) {
        return "data";
      }

      if (
        path.startsWith("/EmployeeWeb/Profile") ||
        path.startsWith("/EmployeeWeb/Company/Linkage") ||
        path.startsWith("/EmployeeWeb/Kenpo/Linkage") ||
        path.startsWith("/EmployeeWeb/AppInformation") ||
        path.startsWith("/EmployeeWeb/FamilyMedical") ||
        path.startsWith("/EmployeeWeb/DataSharing")
      ) {
        return isMobile ? "top" : "settings";
      }

      if (path.startsWith("/EmployeeWeb/Tasks") || path.startsWith("/EmployeeWeb/Task")) {
        return "RespondentList";
      }

      return "top";
    };

    const [activeHeader, setActiveHeader] = useState(getHeaderFromPath());

    useEffect(() => {
      setActiveHeader(getHeaderFromPath());
    }, [location.pathname]);

    const [activePage, setActivePage] = useState(null);
    return (
      <div className="">
        {isMobile ? (
          <>
            <div
              style={{
                /*
                課題・障害番号: IH-BUG-569
                対応日: 2026/06/08
                担当者: 越智
                修正概要: スマホ表示の時、アドレスバーにより画面がスクロールすることへの対応
                */
                minHeight: "100dvh",
                /*
                END
                課題・障害番号: IH-BUG-569
                */
                paddingTop: "env(safe-area-inset-top)",
                paddingBottom: "env(safe-area-inset-bottom)",
                paddingLeft: "env(safe-area-inset-left)",
                paddingRight: "env(safe-area-inset-right)",
                boxSizing: "border-box",
              }}
            >
              <Outlet />
              <MainTabs
                activeHeader={activeHeader}
                setActiveHeader={setActiveHeader}
                isMobile={isMobile}
              />
            </div>
          </>
        ) : (
          <>
            <div>
              <MainTabs
                activeHeader={activeHeader}
                setActiveHeader={setActiveHeader}
              />
              <SidebarPage
                activePage={activePage}
                setActivePage={setActivePage}
                activeHeader={activeHeader}
                setActiveHeader={setActiveHeader}
                outlet={<Outlet />}
              />
            </div>
          </>
        )}
      </div>
    );
  };

  /*
課題・障害番号: ボタン連打制御横展開（IH-BUG-54、IH-BUG-55、IH-BUG-84、KOSHO-141）
対応日: 2026/03/25
担当者: 山原
修正概要: ローディングを表示し、ローディング中は処理を実行しないよう修正
*/
  const CommonLoading = () => {
    const { isCommonLoading, doCommonLoading } = useCommonLoading();
    /*
    課題・障害番号: KOSHO-480
    対応日: 2026/05/19
    担当者: 檜垣
    修正概要: 企業/健保/医療機関/システム管理web において、ローディング中も左サイドバーのタブを操作可能にするため、サイドバー(幅90px)を覆わないオーバーレイ用クラスを付与
    */
    const adminWebPathPrefixes = [
      "/SystemManagementWeb",
      "/CompanyWeb",
      "/KenpoWeb",
      "/HospitalWeb",
    ];
    const isAdminWebPath = adminWebPathPrefixes.some((p) => window.location.pathname.startsWith(p));
    const overlayClassName = isAdminWebPath
      ? "loading-overlay loading-overlay--admin"
      : "loading-overlay";
    /*
    END
    課題・障害番号: KOSHO-480
    */
    return isCommonLoading || doCommonLoading ? (
      <div className={overlayClassName}>
        <div className="spinner"></div>
      </div>
    ) : null;
  };

  return (
    <RumErrorBoundary>
    <AuthProvider>
      {/* 残課題: 固定値になっていた
            対応日: 2026/3/25
            担当者: 越智
            修正概要: 自身の企業を取得し設定 */}
      <UnreadProvider userType={isCompanyAdmin ? "organization" : "employee"}>
        {/* END
            残課題: 固定値になっていた */}
        <CommonLoadingProvider>
          <CommonLoading />
          <Router>
            <AgreementWatcher />
            <Routes>
              {/* システム管理Web */}
              <Route element={<AuthRouteGuard allow={[AUTH.SYSTEM]} />}>
                {/* レイアウトあり */}
                <Route element={<AppLayout />}>
                  <Route
                    path="/SystemManagementWeb/Hospital"
                    element={<Hospital />}
                  />
                  <Route
                    path="/SystemManagementWeb/Hospital/Regist"
                    element={<HospitalEdit />}
                  />
                  <Route
                    path="/SystemManagementWeb/Hospital/Edit"
                    element={<HospitalEdit />}
                  />
                  <Route
                    path="/SystemManagementWeb/Hospital/Delete"
                    element={<HospitalEdit />}
                  />
                  <Route
                    path="/SystemManagementWeb/Hospital/Detail"
                    element={<HospitalEdit />}
                  />
                  <Route
                    path="/SystemManagementWeb/Company"
                    element={<Company />}
                  />
                  <Route
                    path="/SystemManagementWeb/Company/Regist"
                    element={<CompanyEdit />}
                  />
                  <Route
                    path="/SystemManagementWeb/Company/Edit"
                    element={<CompanyEdit />}
                  />
                  <Route
                    path="/SystemManagementWeb/Company/Delete"
                    element={<CompanyEdit />}
                  />
                  <Route
                    path="/SystemManagementWeb/Company/Detail"
                    element={<CompanyEdit />}
                  />
                  <Route
                    path="/SystemManagementWeb/Kenpo"
                    element={<Kenpo />}
                  />
                  <Route
                    path="/SystemManagementWeb/Kenpo/Regist"
                    element={<KenpoEdit />}
                  />
                  <Route
                    path="/SystemManagementWeb/Kenpo/Edit"
                    element={<KenpoEdit />}
                  />
                  <Route
                    path="/SystemManagementWeb/Kenpo/Delete"
                    element={<KenpoEdit />}
                  />
                  <Route
                    path="/SystemManagementWeb/Kenpo/Detail"
                    element={<KenpoEdit />}
                  />
                  <Route
                    path="/SystemManagementWeb/HealthCheck"
                    element={<HealthCheck />}
                  />
                  <Route
                    path="/SystemManagementWeb/Settings"
                    element={<SettingsMain />}
                  />
                  <Route
                    path="/SystemManagementWeb/Settings/Edit"
                    element={<SettingsMain />}
                  />
                  <Route
                    path="/SystemManagementWeb/Settings/DeletedHistory"
                    element={<SettingsMain />}
                  />
                  <Route
                    path="/CompanyWeb/Settings/SettingListPanel"
                    element={<SettingListPanel />}
                  />
                  <Route
                    path="/CompanyWeb/Settings/SettingListPanel/Edit"
                    element={<SettingListPanel />}
                  />
                </Route>
              </Route>
              {/* 管理パート開始 */}
              {/* 企業Web */}
              <Route element={<AuthRouteGuard allow={[AUTH.COMPANY]} />}>
                <Route
                  element={
                    <CompanyWebSidebar
                      stack={stack}
                      setStack={setStack}
                    />
                  }
                >
                  <Route
                    path="/CompanyWeb/Settings/SettingListPanel"
                    element={<Consultation />}
                  />
                  <Route
                    path="/CompanyWeb/Settings/SettingListPanel/Edit"
                    element={<Consultation />}
                  />
                  {/* 
                    課題・障害番号: 残課題-40
                    対応日: 2026/3/23
                    担当者: 久留
                    修正概要: 権限に関する表示制御の実装
                  */}
                  <Route element={<RoleRouteGuard allowRoles={[0, 1, 2]} />}>
                    <Route
                      path="/CompanyWeb/Top"
                      element={<TopPanel openTaskDetailList={openTaskDetailList} />}
                    />
                    <Route
                      path="/CompanyWeb/Task"
                      element={
                        <TaskListPanel
                          openDetailList={openTaskDetailList}
                          excludeTaskId={excludeTaskIdState}
                        />
                      }
                    />
                    <Route
                      path="/CompanyWeb/Tag"
                      element={<Tag />}
                    />
                    <Route
                      path="/CompanyWeb/Survey"
                      element={<SurveyListPanel openDetail={openTaskDetailList} />}
                    />
                    <Route
                      path="/CompanyWeb/Survey/Edit"
                      element={<SurveyEdit />}
                    />
                  </Route>
                  <Route
                    path="/CompanyWeb/User"
                    element={<UserListPanel openDetail={openUserDetail} />}
                  />
                  {/* <Route
                    path="/CompanyWeb/Draft"
                    element={<DraftListPanel />}
                  /> */}
                  <Route
                    path="/CompanyWeb/Settings"
                    element={<SettingListPanel />}
                  />
                </Route>
                {/*
                  END
                  課題・障害番号: 残課題-40
                */}
              </Route>

              {/* 健保Web */}
              <Route element={<AuthRouteGuard allow={[AUTH.KENPO]} />}>
                <Route
                  element={
                    <KenpoWebSidebar
                      stack={stack}
                      setStack={setStack}
                    />
                  }
                >
                  <Route
                    path="/KenpoWeb/Settings/SettingListPanel"
                    element={<Consultation />}
                  />
                  <Route
                    path="/KenpoWeb/Settings/SettingListPanel/Edit"
                    element={<Consultation />}
                  />
                  <Route
                    path="/KenpoWeb/Top"
                    element={<TopPanel openTaskDetailList={openTaskDetailList} />}
                  />
                  <Route
                    path="/KenpoWeb/User"
                    element={<UserListPanel openDetail={openUserDetail} />}
                  />
                  <Route
                    path="/KenpoWeb/Task"
                    element={
                      <TaskListPanel
                        openDetailList={openTaskDetailList}
                        excludeTaskId={excludeTaskIdState}
                      />
                    }
                  />
                  <Route
                    path="/KenpoWeb/Tag"
                    element={<Tag />}
                  />
                  {/* 
                  課題・障害番号: IH-BUG-201
                  対応日: 2026/3/25
                  担当者: 小川
                  修正概要: アンケートからタスクへの遷移処理を追加
                */}
                  <Route
                    path="/KenpoWeb/Survey"
                    element={<SurveyListPanel openDetail={openTaskDetailList} />}
                  />
                  {/*
                END
                課題・障害番号: IH-BUG-201
               */}
                  <Route
                    path="/KenpoWeb/Survey/Edit"
                    element={<SurveyEdit />}
                  />
                  <Route
                    path="/KenpoWeb/Settings"
                    element={<SettingListPanel />}
                  />
                </Route>
              </Route>

              {/* 医療機関Web */}
              <Route element={<AuthRouteGuard allow={[AUTH.HOSPITAL]} />}>
                <Route
                  element={
                    <HospitalWebSidebar
                      stack={stack}
                      setStack={setStack}
                    />
                  }
                >
                  <Route
                    path="/HospitalWeb/Settings/SettingListPanel"
                    element={<Consultation />}
                  />
                  <Route
                    path="/HospitalWeb/Settings/SettingListPanel/Edit"
                    element={<Consultation />}
                  />
                  <Route
                    path="/HospitalWeb/User"
                    element={<UserListPanel openDetail={openUserDetail} />}
                  />
                  <Route
                    path="/HospitalWeb/Task"
                    element={
                      <TaskListPanel
                        openDetailList={openTaskDetailList}
                        excludeTaskId={excludeTaskIdState}
                      />
                    }
                  />
                  <Route
                    path="/HospitalWeb/Tag"
                    element={<Tag />}
                  />
                  <Route
                    path="/HospitalWeb/Survey"
                    /*
  課題・障害番号: リリース前確認
  対応日: 2026/05/13
  担当者: 越智
  修正概要: 医療機関アンケートからタスク詳細への遷移
*/
                    element={<SurveyListPanel openDetail={openTaskDetailList} />}
                    /*
  END
  課題・障害番号: リリース前確認
*/
                  />
                  <Route
                    path="/HospitalWeb/Survey/Edit"
                    element={<SurveyEdit />}
                  />
                  <Route
                    path="/HospitalWeb/Settings"
                    element={<SettingListPanel />}
                  />
                </Route>
              </Route>

              {/* 従業員Web */}
              <Route element={<AuthRouteGuard allow={[AUTH.USER]} />}>
                <Route element={<EmployeeAppLayout />}>
                  {employeeWebRoutes.map((r) => (
                    <Route
                      key={r.path}
                      path={r.path}
                      element={r.element}
                    />
                  ))}
                </Route>

                {employeeRoutes.map((r) => (
                  <Route
                    key={r.path}
                    path={r.path}
                    element={r.element}
                  />
                ))}
              </Route>

              {/* 管理パート終了 */}
              <Route
                path="/"
                element={<Login webFlag={!isMobile} />}
              />
              <Route
                path="/password"
                element={<PasswordChangePage onBack={() => window.history.back()} />}
              />
              <Route
                path="/SetPassword"
                element={
                  <PasswordChangePage
                    requireCurrentPassword={true}
                    onBack={() => window.history.back()}
                    onNext={() => window.history.back()}
                  />
                }
              />
              <Route
                path="/mfa"
                element={<EmailMfaAuthPage onBack={() => window.history.back()} />}
              />
              <Route
                path="/ForgotPassword"
                element={<ForgotPasswordRequestPage />}
              />
              <Route
                path="/ForgotPassword/Reset"
                element={<ForgotPasswordResetPage />}
              />
              {/*
              課題・障害番号: なし
              対応日: 2026/3/27
              担当者: 石川
              修正概要: エラー画面を追加
            */}

              <Route
                path="/error"
                element={<ErrorPage />}
              />
            </Routes>
          </Router>
          {showAgreement && (
            <div className="agreement_overlay">
              <AgreementComponent
                requireTermsAgreement={requireTermsAgreement}
                requirePolicyAgreement={requirePolicyAgreement}
                currentTermsVersion={currentTermsVersion}
                currentPolicyVersion={currentPolicyVersion}
                onAgree={handleAgree}
              />
            </div>
          )}
        </CommonLoadingProvider>
      </UnreadProvider>
    </AuthProvider>
    </RumErrorBoundary>
  );
  /*
END
課題・障害番号: ボタン連打制御横展開（IH-BUG-54、IH-BUG-55、IH-BUG-84、KOSHO-141）
*/
};

export default App;
